import { render, staticRenderFns } from "./CreateSingleCustomer.vue?vue&type=template&id=91a40eca&"
import script from "./CreateSingleCustomer.vue?vue&type=script&lang=js&"
export * from "./CreateSingleCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports